import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';

import { LoginDomainService } from '../../domain/services/login/login.domain.service';
import { UserDomainService } from '../../domain/services/user/user.domain.service';

import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Subscription } from 'rxjs';


@Injectable()
export class LoginService {

  constructor(private http: Http,
    private router: Router,
    private loginDomainService: LoginDomainService,
    private userDomainService: UserDomainService,
    private zone: NgZone) { }


  getOauthInstance(): Observable<any> {
    return this.loginDomainService.getOauthInstance();
  }

  getAccessToken(googleUser: any): Observable<any> {
    return this.userDomainService.login(googleUser);
  }

  setAccessToken(accessToken: any) {
    this.loginDomainService.setCurrentAccessToken(accessToken);
  }
  navigate(): void {
    this.router.navigate(['/auth']);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/services/login.service.ts